module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "introduce"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('v-icon', [_vm._v("map")]), _vm._v("상품 소개서")], 1), _vm._v(" "), _c('div', {
    staticClass: "items_wrapper"
  }, [_c('div', {
    staticClass: "introduce_items",
    attrs: {
      "id": "introduce_items_1"
    }
  }, [_c('img', {
    staticClass: "down_img",
    attrs: {
      "src": "static/img/interworksmedia.png",
      "alt": "인터웍스 매체 소개서"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "down_img",
    attrs: {
      "src": "static/img/interplay.png",
      "alt": "인터플레이 상품 소개서"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "down_wrap"
  }, [_c('a', {
    attrs: {
      "href": _vm.iw,
      "download": ""
    }
  }, [_c('span', {
    attrs: {
      "title": _vm.msg_1.a
    }
  }, [_vm._v("인터웍스미디어 통합소개서")]), _vm._v(" "), _c('div', {
    staticClass: "down_btn",
    attrs: {
      "title": _vm.msg_1.a
    }
  }, [_c('img', {
    attrs: {
      "src": "static/img/down-icon.png",
      "alt": "down"
    }
  })])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.iwCase2,
      "download": ""
    }
  }, [_c('span', {
    attrs: {
      "title": _vm.msg_1.a
    }
  }, [_vm._v("2022인터플레이 상품소개서")]), _vm._v(" "), _c('div', {
    staticClass: "down_btn",
    attrs: {
      "title": _vm.msg_1.a
    }
  }, [_c('img', {
    attrs: {
      "src": "static/img/down-icon.png",
      "alt": "down"
    }
  })])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.iwCase,
      "download": ""
    }
  }, [_c('span', {
    attrs: {
      "title": _vm.msg_1.b
    }
  }, [_vm._v("집행사례")]), _vm._v(" "), _c('div', {
    staticClass: "down_btn",
    attrs: {
      "title": _vm.msg_1.b
    }
  }, [_c('img', {
    attrs: {
      "src": "static/img/down-icon.png",
      "alt": "down"
    }
  })])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0a5a0360","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/mainScreen/Introduce.vue
// module id = 830
// module chunks = 1